//@mutations
export const mutations={
  updateUserInfo(state:any, userInfo:any) {
    state.userInfo = userInfo;
  }

}
